import { api } from './axios';

/**
 * Duel Voting API — Голосования в дуэлях
 * @see api_duel_vote_reference.md
 */

/**
 * Проголосовать за трек в раунде дуэли
 * @param {string} duelId - ID дуэли
 * @param {string} roundId - ID раунда
 * @param {Object} data - Данные голоса
 * @param {string} data.trackId - ID трека
 * @param {number} data.score - Оценка от 1 до 10
 * @param {string} [data.comment] - Комментарий к голосу
 * @param {string} [data.voiceCommentId] - ID аудио-комментария
 * @returns {Promise<Object>} Созданный голос
 */
export const voteForTrack = (duelId, roundId, data) => {
    return api.post(`/duels/${duelId}/rounds/${roundId}/vote`, data).then((res) => res.data);
};

/**
 * Обновить свой голос за трек
 * @param {string} duelId - ID дуэли
 * @param {string} roundId - ID раунда
 * @param {Object} data - Данные для обновления
 * @param {string} data.trackId - ID трека
 * @param {number} data.score - Новая оценка от 1 до 10
 * @param {string} [data.comment] - Новый комментарий
 * @returns {Promise<Object>} Обновлённый голос
 */
export const updateVote = (duelId, roundId, data) => {
    return api.put(`/duels/${duelId}/rounds/${roundId}/vote`, data).then((res) => res.data);
};

/**
 * Удалить свой голос за трек
 * @param {string} duelId - ID дуэли
 * @param {string} roundId - ID раунда
 * @param {string} trackId - ID трека
 * @returns {Promise<void>}
 */
export const deleteVote = (duelId, roundId, trackId) => {
    return api.delete(`/duels/${duelId}/rounds/${roundId}/vote/${trackId}`).then((res) => res.data);
};

/**
 * Получить результаты голосования в раунде
 * @param {string} duelId - ID дуэли
 * @param {string} roundId - ID раунда
 * @returns {Promise<Object>} Результаты голосования
 */
export const getRoundResults = (duelId, roundId) => {
    return api.get(`/duels/${duelId}/rounds/${roundId}/results`).then((res) => res.data);
};

/**
 * Проверить, голосовал ли текущий пользователь
 * @param {string} duelId - ID дуэли
 * @param {string} roundId - ID раунда
 * @param {string} [trackId] - ID трека (опционально)
 * @returns {Promise<{hasVoted: boolean, votedForTrackId: string|null}>}
 */
export const checkVoted = (duelId, roundId, trackId) => {
    const params = trackId ? { trackId } : {};
    return api.get(`/duels/${duelId}/rounds/${roundId}/voted`, { params }).then((res) => res.data);
};

/**
 * Получить все мои голоса в раунде
 * @param {string} duelId - ID дуэли
 * @param {string} roundId - ID раунда
 * @returns {Promise<Array>} Список моих голосов
 */
export const getMyVotes = (duelId, roundId) => {
    return api.get(`/duels/${duelId}/rounds/${roundId}/my-votes`).then((res) => res.data);
};

export default {
    voteForTrack,
    updateVote,
    deleteVote,
    getRoundResults,
    checkVoted,
    getMyVotes
};

